import script from "./PhotographerPlans.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotographerPlans.vue?vue&type=script&setup=true&lang=js"

import "./PhotographerPlans.vue?vue&type=style&index=0&id=2e5a79f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e5a79f0"]])

export default __exports__